/*
  Extras da esteira de compra entram no carrinho junto com o produto:
  - acessórios marcados no HALO Compre junto (blocks/halo-compre-junto.liquid);
  - opções pagas escolhidas nos blocos HALO Escolha (ex.: estojo, garantia), com a
    informação do item (propriedade) quando configurada.

  Fluxo (aprovado pelo Pedro; arquivos do botão e da Yampi intactos):
  - No clique de "Adicionar ao carrinho" (ou do botão da barra fixa) com algum extra, o
    clique é segurado, os extras são adicionados pela API do carrinho da Shopify
    (/cart/add.js) e o mesmo clique é repetido para o tema adicionar o produto e abrir o
    carrinho, que já mostra tudo junto.
  - Sem extra nenhum, nada muda. Se o tamanho ainda não foi escolhido (estilo HALO do
    seletor), não faz nada: a trava do tamanho age primeiro e nenhum extra entra.
  - Se um extra falhar (ex.: esgotou), o produto principal segue para o carrinho e um aviso
    aparece (no Compre junto ou no resumo).
  - Cores em pop-up (ex.: pulseiras extras, snippets/halo-cores.liquid): a linha abre o pop-up;
    o cliente vê as fotos e escolhe quantas quiser de cada cor. Cada cor tem um campo escondido
    com a quantidade (data-hcj-qtd); as escolhidas entram no carrinho como os outros extras.
  - Depois de adicionar, as escolhas continuam marcadas (o cliente fecha o carrinho e vê o que
    escolheu). Se clicar em adicionar de novo, os extras que já estão no carrinho não entram
    outra vez; só o produto e os extras que faltam.
*/
(function () {
  'use strict';

  if (window.haloCompreJunto) return;
  window.haloCompreJunto = true;

  var passing = false;

  // Seção de produto que tem extras (Compre junto ou Escolha).
  function root() {
    var el = document.querySelector('[data-hcj], [data-halo-escolha]');
    return el ? el.closest('xo-product') || document : null;
  }

  function selected(scope) {
    return Array.prototype.slice.call(
      scope.querySelectorAll('[data-hcj-check]:checked:not(:disabled), [data-halo-opcao]:checked:not(:disabled)')
    );
  }

  // Tamanho obrigatório ainda não escolhido (estilo HALO do seletor de variantes).
  function sizePending() {
    var picker = document.querySelector('.halo-picker[data-halo-require-size]');
    return !!(picker && picker.dataset.haloSizeChosen !== 'true' && picker.querySelector('[data-halo-size]'));
  }

  // Só os botões que compram o produto desta página: formulário de compra dentro da mesma
  // seção de produto dos extras, ou o botão da barra fixa.
  function buysThisProduct(el, scope) {
    if (el.closest('[data-sticky-atc-submit]')) return true;
    var form = el.closest('form[action*="/cart/add"]');
    return !!(form && scope !== document && scope.contains(form));
  }

  function cartAddUrl() {
    var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return base + 'cart/add.js';
  }

  function toItem(input) {
    var item = { id: Number(input.value), quantity: Math.max(1, Number(input.dataset.hcjQtd) || 1) };
    if (input.dataset.propNome && input.dataset.propValor) {
      item.properties = {};
      item.properties[input.dataset.propNome] = input.dataset.propValor;
    }
    return item;
  }

  function cartUrl() {
    var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return base + 'cart.js';
  }

  // Extras que ainda não estão no carrinho (evita duplicar quando o cliente adiciona de novo).
  function missing(inputs) {
    return fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : { items: [] };
      })
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (item) {
          inCart[item.variant_id] = true;
        });
        return inputs.filter(function (input) {
          return !inCart[Number(input.value)];
        });
      })
      .catch(function () {
        return inputs;
      });
  }

  function showError(scope) {
    var status = scope.querySelector('[data-hcj-status]');
    if (status) status.textContent = status.dataset.error || '';
  }

  document.addEventListener('click', function (e) {
    if (passing) return;
    var button = e.target.closest && e.target.closest('xo-cart-add, [name="add"], [type="submit"], [data-sticky-atc-submit]');
    if (!button) return;
    // O clique é repetido no mesmo elemento que o cliente clicou (o botão de verdade),
    // onde o tema e a barra fixa escutam.
    var clicked = e.target.closest('button, [type="submit"], [data-sticky-atc-submit]') || button;
    var scope = root();
    if (!scope || !buysThisProduct(button, scope)) return;
    var inputs = selected(scope);
    if (!inputs.length || sizePending()) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (scope.haloBusy) return;
    scope.haloBusy = true;

    var status = scope.querySelector('[data-hcj-status]');
    if (status) status.textContent = '';

    missing(inputs)
      .then(function (toAdd) {
        if (!toAdd.length) return;
        return fetch(cartAddUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: toAdd.map(toItem) }),
        }).then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
        });
      })
      .catch(function () {
        showError(scope);
      })
      .then(function () {
        scope.haloBusy = false;
        // Repete o clique para o tema adicionar o produto e abrir o carrinho.
        passing = true;
        try {
          clicked.click();
        } finally {
          passing = false;
        }
      });
  }, true);

  // Trocar a variação de um acessório (ex.: cor da capa) atualiza o item, a foto e o preço, e já o marca.
  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('[data-hcj-variant]');
    if (!pill || pill.disabled) return;
    var item = pill.closest('[data-hcj-item]');
    var input = item && item.querySelector('[data-hcj-check]');
    if (!input) return;
    item.querySelectorAll('[data-hcj-variant]').forEach(function (other) {
      other.setAttribute('aria-pressed', other === pill ? 'true' : 'false');
    });
    input.value = pill.dataset.hcjVariant;
    if (pill.dataset.preco) input.dataset.hcjPreco = pill.dataset.preco;
    // Foto da variante escolhida (ex.: capa Chumbo).
    if (pill.dataset.imagem) {
      var media = item.querySelector('.halo-compre-junto__media');
      var img = media && media.querySelector('img');
      if (media && !img) {
        media.textContent = '';
        img = document.createElement('img');
        img.alt = '';
        img.sizes = '52px';
        media.appendChild(img);
      }
      if (img) {
        img.srcset = pill.dataset.imagemSrcset || '';
        img.src = pill.dataset.imagem;
      }
    }
    input.checked = true;
    document.dispatchEvent(new CustomEvent('halo:extras'));
  });

  // Cores em pop-up.

  // Fotos da cor no pop-up: a pílula de navegação da HALO Galeria (setas, bolinhas e pausa).
  // A barra da bolinha ativa enche no tempo de cada foto (CSS) e, quando termina, passa para a
  // próxima. Sem troca automática com "reduzir movimento" ou quando a cor tem uma foto só.
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function track(dialog) {
    var group = dialog.querySelector('[data-hcj-fotos]:not([hidden])');
    return group && group.querySelector('.halo-cores__trilho');
  }

  function slideIndex(dialog) {
    var el = track(dialog);
    return el ? Math.round(el.scrollLeft / Math.max(1, el.clientWidth)) : 0;
  }

  function markDot(dialog, index) {
    var dots = dialog.querySelector('[data-hcj-dots]');
    if (!dots || dots.haloAtivo === index) return;
    dots.haloAtivo = index;
    Array.prototype.forEach.call(dots.children, function (dot, k) {
      dot.classList.toggle('is-ativo', k === index);
    });
  }

  function goTo(dialog, index) {
    var el = track(dialog);
    if (!el) return;
    var count = el.children.length;
    var next = (index + count) % count;
    // Da última para a primeira: pula direto (sem passar por todas as bolinhas no caminho).
    var smooth = !reduceMotion.matches && Math.abs(next - slideIndex(dialog)) === 1;
    el.scrollTo({ left: next * el.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    markDot(dialog, next);
  }

  // Monta as bolinhas da cor visível e liga a troca automática.
  function buildNav(dialog) {
    var el = track(dialog);
    var nav = dialog.querySelector('[data-hcj-nav]');
    var dots = dialog.querySelector('[data-hcj-dots]');
    var count = el ? el.children.length : 0;
    dots.textContent = '';
    dots.haloAtivo = -1;
    nav.hidden = count < 2;
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('span');
      dot.className = 'halo-cores__dot';
      dot.dataset.hcjDot = String(i);
      dot.innerHTML = '<span class="halo-cores__dot-barra"><span class="halo-cores__dot-enche"></span></span>';
      dots.appendChild(dot);
    }
    markDot(dialog, 0);
    if (el && !el.haloOuvindo) {
      el.haloOuvindo = true;
      el.addEventListener(
        'scroll',
        function () {
          markDot(dialog, slideIndex(dialog));
        },
        { passive: true }
      );
    }
    var playing = count > 1 && !reduceMotion.matches;
    dialog.classList.toggle('is-rodando', playing);
    dialog.querySelector('[data-hcj-pausa]').hidden = !playing;
    if (!dialog.haloAutoplay) {
      dialog.haloAutoplay = true;
      // A barra da bolinha ativa terminou de encher: próxima foto.
      dots.addEventListener('animationend', function () {
        if (dialog.open && !dialog.hasAttribute('data-pausado')) goTo(dialog, slideIndex(dialog) + 1);
      });
    }
  }

  function setPaused(dialog, paused) {
    var button = dialog.querySelector('[data-hcj-pausa]');
    if (paused) dialog.setAttribute('data-pausado', '');
    else dialog.removeAttribute('data-pausado');
    button.dataset.state = paused ? 'paused' : 'playing';
    button.setAttribute('aria-label', paused ? button.dataset.labelPlay : button.dataset.labelPause);
  }

  function money(cents, item) {
    try {
      return new Intl.NumberFormat(item.dataset.idioma || 'pt-BR', {
        style: 'currency',
        currency: item.dataset.moeda || 'BRL',
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  // "R$ 1.234,56" vira 123456 (centavos): preço digitado no item.
  function parsePrice(text) {
    var clean = String(text || '').replace(/[^\d,.]/g, '');
    if (!clean) return null;
    if (clean.indexOf(',') > -1) clean = clean.replace(/\./g, '').replace(',', '.');
    var value = parseFloat(clean);
    return isNaN(value) ? null : Math.round(value * 100);
  }

  function fieldOf(item, row) {
    return item.querySelector('[data-hcj-cor-campo="' + row.dataset.hcjCor + '"]');
  }

  // Mostra a foto de uma cor e marca a amostra dela.
  function preview(dialog, row) {
    if (!row) return;
    dialog.querySelectorAll('[data-hcj-ver]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.closest('[data-hcj-cor]') === row ? 'true' : 'false');
    });
    dialog.querySelectorAll('[data-hcj-fotos]').forEach(function (group) {
      var on = group.dataset.hcjFotos === row.dataset.hcjCor;
      group.hidden = !on;
      if (on) {
        var el = group.querySelector('.halo-cores__trilho');
        if (el) el.scrollLeft = 0;
      }
    });
    buildNav(dialog);
  }

  // Desenha o pop-up, a linha do item e avisa o resumo a partir das quantidades nos campos.
  function render(item, notify) {
    var dialog = item.querySelector('[data-hcj-dialogo]');
    var total = 0;
    var totalFull = 0;
    var count = 0;
    var parts = [];
    var firstPhoto = null;
    // Preço na compra junto só nas primeiras unidades (ex.: 1 pulseira); as outras, preço cheio.
    var limit = Number(dialog.dataset.promoLimite) || 0;
    var promoLeft = limit > 0 ? limit : Infinity;
    var promoCount = 0;
    var promoUnit = 0;
    var fullUnit = 0;
    dialog.querySelectorAll('[data-hcj-cor]').forEach(function (row) {
      var field = fieldOf(item, row);
      var qty = Number(field.dataset.hcjQtd) || 0;
      var max = Number(dialog.dataset.max) || 5;
      var available = !row.classList.contains('is-esgotada');
      row.classList.toggle('is-escolhida', qty > 0);
      row.querySelector('[data-hcj-n]').textContent = String(qty);
      row.querySelector('[data-hcj-menos]').disabled = qty === 0;
      row.querySelector('[data-hcj-mais]').disabled = !available || qty >= max;
      if (qty > 0) {
        var unit = parsePrice(field.dataset.hcjPrecoTexto);
        if (unit == null) unit = Number(field.dataset.hcjPreco) || 0;
        var full = parsePrice(field.dataset.hcjPrecoCheioTexto);
        if (full == null) full = Number(field.dataset.hcjPreco) || unit;
        full = Math.max(unit, full);
        var promoUnits = Math.min(qty, promoLeft);
        promoLeft -= promoUnits;
        promoCount += promoUnits;
        promoUnit = unit;
        fullUnit = full;
        total += unit * promoUnits + full * (qty - promoUnits);
        totalFull += full * qty;
        count += qty;
        parts.push((qty > 1 ? qty + '× ' : '') + row.dataset.nome);
        if (!firstPhoto && row.dataset.foto) firstPhoto = row;
      }
    });

    var sum = dialog.querySelector('[data-hcj-soma]');
    var done = dialog.querySelector('[data-hcj-concluir]');
    var word = count === 1 ? dialog.dataset.unidade : dialog.dataset.unidades;
    // "3 pulseiras · R$ 390,00", com o preço cheio riscado antes quando há preço promocional.
    sum.textContent = count ? count + ' ' + word + ' · ' : dialog.dataset.vazio;
    if (count && totalFull > total) {
      var struck = document.createElement('s');
      struck.textContent = money(totalFull, item);
      sum.appendChild(struck);
      sum.appendChild(document.createTextNode(' '));
    }
    if (count) sum.appendChild(document.createTextNode(money(total, item)));
    sum.classList.toggle('is-ativa', count > 0);
    // Passou do limite do preço promocional: "1 por R$ 97,00 + 2 por R$ 130,00".
    var detail = dialog.querySelector('[data-hcj-detalhe]');
    if (detail) {
      var extra = count - promoCount;
      var showDetail = limit > 0 && promoCount > 0 && extra > 0 && promoUnit < fullUnit;
      detail.hidden = !showDetail;
      detail.textContent = showDetail
        ? (dialog.dataset.detalhe || '')
            .replace('[a]', promoCount)
            .replace('[b]', extra)
            .replace('[promo]', money(promoUnit, item))
            .replace('[cheio]', money(fullUnit, item))
        : '';
    }
    done.textContent = count ? done.dataset.comItens : done.dataset.semItens;
    done.classList.toggle('is-pronto', count > 0);

    var line = item.querySelector('[data-hcj-cor-linha]');
    if (line) line.textContent = count ? parts.join(', ') : line.dataset.padrao;
    var price = item.querySelector('[data-hcj-preco-linha]');
    if (price) price.textContent = count ? money(total, item) : price.dataset.padrao;
    var priceFull = item.querySelector('[data-hcj-cheio-linha]');
    if (priceFull) priceFull.textContent = count ? money(totalFull, item) : priceFull.dataset.padrao;
    var action = item.querySelector('[data-hcj-acao]');
    if (action) action.textContent = count ? action.dataset.trocar : action.dataset.escolher;
    var img = item.querySelector('.halo-compre-junto__media img');
    if (img && firstPhoto) {
      img.srcset = firstPhoto.dataset.fotoSrcset || '';
      img.src = firstPhoto.dataset.foto;
    }
    if (notify) document.dispatchEvent(new CustomEvent('halo:extras'));
  }

  function change(item, row, delta) {
    var field = fieldOf(item, row);
    var max = Number(item.querySelector('[data-hcj-dialogo]').dataset.max) || 5;
    var qty = Math.min(max, Math.max(0, (Number(field.dataset.hcjQtd) || 0) + delta));
    field.dataset.hcjQtd = String(qty);
    field.checked = qty > 0;
    render(item, true);
  }

  function openColors(item) {
    var dialog = item.querySelector('[data-hcj-dialogo]');
    if (!dialog) return;
    var chosen = item.querySelector('[data-hcj-cor-campo]:checked');
    var row = chosen && dialog.querySelector('[data-hcj-cor="' + chosen.value + '"]');
    setPaused(dialog, false);
    preview(dialog, row || dialog.querySelector('[data-hcj-cor]:not(.is-esgotada)') || dialog.querySelector('[data-hcj-cor]'));
    render(item, false);
    if (dialog.showModal) dialog.showModal();
    else dialog.setAttribute('open', '');
    dialog.scrollTop = 0;
  }

  function closeColors(dialog) {
    if (dialog.close) dialog.close();
    else dialog.removeAttribute('open');
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target.closest) return;
    var opener = target.closest('[data-hcj-abrir]');
    if (opener) {
      openColors(opener.closest('[data-hcj-item]'));
      return;
    }
    var dialog = target.closest('[data-hcj-dialogo]');
    if (!dialog) return;
    // Clique no fundo escuro (fora da folha) fecha.
    if (target === dialog) {
      var rect = dialog.getBoundingClientRect();
      var inside = e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom;
      if (!inside) closeColors(dialog);
      return;
    }
    var item = dialog.closest('[data-hcj-item]');
    var row = target.closest('[data-hcj-cor]');
    if (target.closest('[data-hcj-mais]')) {
      preview(dialog, row);
      change(item, row, 1);
    } else if (target.closest('[data-hcj-menos]')) {
      change(item, row, -1);
    } else if (target.closest('[data-hcj-ver]')) {
      preview(dialog, row);
    } else if (target.closest('[data-hcj-dot]')) {
      goTo(dialog, Number(target.closest('[data-hcj-dot]').dataset.hcjDot));
    } else if (target.closest('[data-hcj-anterior]')) {
      goTo(dialog, slideIndex(dialog) - 1);
    } else if (target.closest('[data-hcj-proxima]')) {
      goTo(dialog, slideIndex(dialog) + 1);
    } else if (target.closest('[data-hcj-pausa]')) {
      setPaused(dialog, !dialog.hasAttribute('data-pausado'));
    } else if (target.closest('[data-hcj-concluir], [data-hcj-fechar]')) {
      closeColors(dialog);
    }
  });
})();
